export function ensureFloat(input: string | number): number {
  if (typeof input === 'number') return input
  return parseFloat(input.replace(',', '.'))
}